import React from "react";
import { Outlet,useParams } from "react-router-dom";

import Footer from "../../../../components/common/Footer";
import Tabs from "../../../../components/common/Tabs";



function PropertyTabs() {
  const { id } = useParams();
  const tabs = [
    {
      link: `/property-tabs/property/${id}`,
      title: "property",
    },
    {
      link: `/properties`,
      title: "budget",
    },
    {
      link: `/properties`,
      title: "marketing",
    },
    {
      link: `/properties`,
      title: "comparabels",
    },
  ];
  return (
    <div className="page-container">
      <div className="main-container">
        <Tabs tabs={tabs} keepFirstLinkActive={true}/>
        <Outlet />
        {/* Footer  */}
        <Footer />
      </div>
    </div>
  );
}

export default PropertyTabs;